import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-quantity"
export default class extends Controller {
  static targets = [
    "input",
    "productTotal",
    "installationTotal",
    "installationCheckbox",
    "grandTotal",
  ]
  static values = { unitPriceCents: Number, stock: Number, installationPriceCents: Number }

  connect() {
    this.recalculate()
  }

  increment() {
    this.inputTarget.value = this.clamp(this.currentQuantity + 1)
    this.recalculate()
  }

  decrement() {
    this.inputTarget.value = this.clamp(this.currentQuantity - 1)
    this.recalculate()
  }

  recalculate() {
    this.inputTarget.value = this.clamp(this.currentQuantity)
    const qty = this.currentQuantity

    const productTotalCents = this.unitPriceCentsValue * qty
    this.productTotalTarget.textContent = this.formatMoney(productTotalCents)

    let grandTotalCents = productTotalCents
    const installationChecked = this.hasInstallationCheckboxTarget && this.installationCheckboxTarget.checked

    if (this.hasInstallationTotalTarget) {
      const installationTotalCents = this.installationPriceCentsValue * qty
      this.installationTotalTarget.textContent = this.formatMoney(installationTotalCents)

      if (installationChecked) {
        grandTotalCents += installationTotalCents
      }
    }

    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatMoney(grandTotalCents)
    }
  }

  get currentQuantity() {
    return parseInt(this.inputTarget.value, 10) || 1
  }

  clamp(quantity) {
    const max = this.stockValue > 0 ? this.stockValue : 1
    return Math.min(Math.max(quantity, 1), max)
  }

  formatMoney(cents) {
    const euros = (cents / 100).toFixed(2).replace(".", ",")
    return `€${euros}`
  }
}
